import { render } from "./WorkList.vue?vue&type=template&id=201380c5&ts=true"
import script from "./WorkList.vue?vue&type=script&lang=ts"
export * from "./WorkList.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jenkins/agent/workspace/Project_moydom_master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__